import React from 'react';
import { FadeIn } from './FadeIn';
const citations = [{
  topic: 'On Curcumin:',
  quote: '"Curcumin inhibits NF-kB, the master regulator of the inflammatory response, with potency comparable to prescription anti-inflammatories but without their gastrointestinal side effects."',
  source: '— Journal of Medicinal Food, 2016'
}, {
  topic: 'On Leaky Gut:',
  quote: '"Intestinal hyperpermeability is a documented pathophysiological mechanism in rheumatoid arthritis and osteoarthritis. Restoration of the intestinal barrier reduces systemic inflammatory markers."',
  source: '— Nutrients Journal, 2019'
}, {
  topic: 'On Bone Broth:',
  quote: '"Glycosaminoglycans and hydrolyzed collagen derived from bone broth have superior bioavailability to equivalent commercial supplements at a fraction of the cost."',
  source: '— Journal of Agricultural and Food Chemistry, 2017'
}];
export function Science() {
  return <section className="bg-white py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-213">
      <div className="max-w-4xl mx-auto" data-id="element-214">
        <FadeIn data-id="element-215">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-black mb-12" data-id="element-216">
            It's Not Magic. It's Biochemistry.
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-217">
          {citations.map((item, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-218">
              <div className="bg-sage-light/20 border-l-4 border-sage-green p-6 md:p-8 rounded-r-xl" data-id="element-219">
                <h3 className="font-bold text-forest-green text-lg mb-3" data-id="element-220">
                  {item.topic}
                </h3>
                <p className="font-serif italic text-xl text-gray-800 leading-relaxed mb-4" data-id="element-221">
                  {item.quote}
                </p>
                <p className="text-sm font-semibold text-gray-600 uppercase tracking-wide" data-id="element-222">
                  {item.source}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}